import {styled} from "@mui/styles";

export const TabsContainerLeftButtons = styled("div")({
    display: "flex",
    gap: "10px",
    alignItems: "center",
    height: "48px",
    padding: "10px",
});
